import React from "react";
import SafeMessageText from "./SafeMessageText";

/* Channel-aware conversation starters. `send` is the text dispatched to the
   agent via handleSendMessage; `label`/`icon`/`iconBg` are what the user sees. */
const SUGGESTIONS = {
  web: [
    { label: "Track a shipment", send: "I want to track a shipment", icon: "📦", iconBg: "var(--accent-soft)" },
    { label: "Get shipping rates", send: "I want to check shipping rates", icon: "₹", iconBg: "rgba(20, 184, 166, 0.14)" },
    { label: "Find nearest branch", send: "Find the nearest DTDC branch to my pincode", icon: "📍", iconBg: "var(--accent-soft)" },
    { label: "Raise an issue", send: "I want to raise an issue", icon: "⚑", iconBg: "rgba(220, 38, 38, 0.1)" },
  ],
  channelpartners: [
    { label: "Track a shipment", send: "I want to track a shipment", icon: "📦", iconBg: "var(--accent-soft)" },
    { label: "Check serviceability", send: "Check pincode serviceability", icon: "📍", iconBg: "var(--accent-soft)" },
    { label: "Get shipping rates", send: "I want to check shipping rates", icon: "₹", iconBg: "rgba(20, 184, 166, 0.14)" },
    { label: "Raise an issue", send: "I want to raise an issue", icon: "⚑", iconBg: "rgba(220, 38, 38, 0.1)" },
  ],
};

function ChevronIcon() {
  return (
    <svg
      className="suggestion-chip-arrow"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

function WelcomeScreen({ welcomeText, channelType, headerIcon, onSelectPrompt }) {
  const prompts = SUGGESTIONS[channelType] || SUGGESTIONS.web;

  return (
    <div className="welcome-screen">
      <div className="welcome-avatar-wrap">
        <div className="welcome-avatar-glow" aria-hidden="true" />
        <img className="welcome-avatar" src={headerIcon} alt="DIVA" />
      </div>
      <div className="welcome-greeting">How can I help you today?</div>
      {welcomeText ? (
        <SafeMessageText className="welcome-sub" text={welcomeText} />
      ) : (
        <div className="welcome-sub">
          I'm here to help with tracking, serviceability, delivery times, rates, and more.
        </div>
      )}
      <div className="suggestion-list">
        {prompts.map((p) => (
          <button
            key={p.label}
            type="button"
            className="suggestion-row"
            onClick={() => onSelectPrompt(p.send)}
          >
            <span className="suggestion-row-left">
              <span className="suggestion-icon-box" style={{ background: p.iconBg }}>{p.icon}</span>
              <span>{p.label}</span>
            </span>
            <ChevronIcon />
          </button>
        ))}
      </div>
    </div>
  );
}

export default WelcomeScreen;
